import interpol from "../../../images/MobileGalary/interpol.webp";
import grotta from "../../../images/MobileGalary/grotta.webp";
import bluehouse_image from "../../../images/MobileGalary/20180808_164113.webp";
import Activities from "../../../images/MobileGalary/Activities.webp";
import Northernlights from "../../../images/MobileGalary/NorthernLights.webp";
import NeighbourHood from "../../../images/view-gallery/neighborhood.webp";
import greenhouse from "../../../images/MobileGalary/greenhouse.webp";
import threebedroom from "../../../images/MobileGalary/IMG_3846.webp";

export const Rooms = [
  {
    title: "Double/Twin",
    From: "from €90 per night",
    image: "https://bluehouse.is/static/media/dt1.feb270dd.jpg",
    Link: "https://beds24.com/booking2.php?propid=3578&layout=1",
  },
  {
    title: "Triple/Quadruple Room",
    From: "from €110 per night",
    image: "https://bluehouse.is/static/media/t1.7a599542.jpg",
    Link: "https://beds24.com/booking2.php?propid=3578&layout=1",
  },
  {
    title: "Family Room",
    From: "from €150 per night",
    image: grotta,
    Link: "https://beds24.com/booking2.php?propid=3578&layout=1",
  },
  {
    title: "Two-bedroom Appartment",
    From: "from €100 per night",
    image: interpol,
    Link: "https://beds24.com/booking2.php?propid=3578&layout=1",
  },
];
export const Houses = [
  {
    title: "Blue House",
    From: "",
    image: bluehouse_image,
    Link: "https://beds24.com/booking2.php?propid=3578&layout=1",
  },
  {
    title: "Green House",
    From: "",
    image: greenhouse,
    Link: "https://beds24.com/booking2.php?propid=3578&layout=1",
  },
  {
    title: "GNL",
    From: "",
    image: threebedroom,
    Link: "https://beds24.com/booking2.php?propid=3578&layout=1",
  },
];

export const Surroundings = [
  {
    title: "Northern Lights",
    From: "",
    image: Northernlights,
    Link: "https://blog.bluehouse.is/",
  },
  {
    title: "Neighbourhood",
    From: "",
    image: NeighbourHood,
    // Link: "bluehouseis.bitbucket.io\src\images\view-gallery\neighborhood.jpeg"
    Link: "https://blog.bluehouse.is/",
  },
  {
    title: "Activities",
    From: "",
    image: Activities,
    Link: "https://blog.bluehouse.is/",
  },
];
